export function useXPixel() {
  // Use useRuntimeConfig from Nuxt to access public runtime config
  const config = useRuntimeConfig()
  const xPixelTrackingEnabled = Boolean(config.public?.xPixelTrackingEnabled)
  if (!xPixelTrackingEnabled) {
    return {
      loadXPixel: () => {},
      trackEventXPixel: () => {},
    }
  }
  const loadXPixel = () => {
    console.debug('Loading Twitter Pixel')
    if (typeof window.twq !== 'undefined') return
    const twq = function (...args: any[]) {
      if ((twq as any).exe) {
        (twq as any).exe(...args)
      } else {
        (twq as any).queue.push(args)
      }
    }
    Object.assign(twq, {
      version: '1.1',
      queue: [] as any[],
      loaded: false,
    })
    window.twq = twq as typeof window.twq
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://static.ads-twitter.com/uwt.js'
    script.onload = () => {
      ;(window.twq as any).loaded = true
    }
    document.head.appendChild(script)
    console.debug('Twitter Pixel script added to the document head')
  }

  const trackEventXPixel = (eventId: string, data: Record<string, any> = {}) => {
    try {
      console.debug(`Tracking Twitter Pixel event: ${eventId}`, data)
      if (
        typeof window.twq === 'function' &&
        typeof window.twq.version === 'string' &&
        Array.isArray(window.twq.queue)
      ) {
        window.twq('event', eventId, data)
        console.debug(`Twitter Pixel event ${eventId} tracked successfully`, data)
      } else {
        console.warn(`Twitter Pixel event ${eventId} skipped: twq not ready`)
      }
    } catch (err) {
      console.warn(`Twitter Pixel event ${eventId} failed:`, err)
    }
  }

  return { loadXPixel, trackEventXPixel }
}
